import { render } from "./MotoPurchaseForm.vue?vue&type=template&id=e4223236&scoped=true"
import script from "./MotoPurchaseForm.vue?vue&type=script&lang=js"
export * from "./MotoPurchaseForm.vue?vue&type=script&lang=js"

import "./MotoPurchaseForm.vue?vue&type=style&index=0&id=e4223236&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e4223236"]])

export default __exports__